var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInactiveIntake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 14.6136,
    stroke: "#2BA3DE",
    strokeWidth: 2.77273
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.385 10.4165C17.385 9.65159 16.7649 9.0315 16 9.0315C15.2351 9.0315 14.615 9.65159 14.615 10.4165H17.385ZM14.615 16.9879C14.615 17.7528 15.2351 18.3729 16 18.3729C16.7649 18.3729 17.385 17.7528 17.385 16.9879H14.615ZM14.615 10.4165V16.9879H17.385V10.4165H14.615Z",
    fill: "#2BA3DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6148 21.5434C14.6148 22.3083 15.2348 22.9284 15.9998 22.9284C16.7647 22.9284 17.3848 22.3083 17.3848 21.5434H14.6148ZM17.3848 21.417C17.3848 20.6521 16.7647 20.032 15.9998 20.032C15.2348 20.032 14.6148 20.6521 14.6148 21.417H17.3848ZM17.3848 21.5434V21.417H14.6148V21.5434H17.3848Z",
    fill: "#2BA3DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveIntake);
export default __webpack_public_path__ + "static/media/inactive-intake.1c8a30065426014589ba7ce3f4bd096b.svg";
export { ForwardRef as ReactComponent };